import React, { useEffect, useState, useRef } from 'react';
import '@arianee/arn-components'; // Register ARN web components
import customEventBus from '@common/scripts/libs/eventBus';
import { useTranslation } from 'react-i18next';
import analytics from '@utils/analytics';
const WalletConnectBtn = (props) => {
    const [arnClientReady, setArnClientReady] = useState(!!window.arnClient);
    const { t } = useTranslation();
    const [enabled, setEnabled] = useState(true);
    const connectBtn = useRef(null);
    useEffect(() => {
        customEventBus.on('arnClient:ready', (data) => {
            setArnClientReady(data.ready);
        });
        customEventBus.on('wallet:arn-button:status', (data) => {
            setEnabled(data.enabled);
        });
    }, []);
    useEffect(() => {
        var _a;
        (_a = connectBtn.current) === null || _a === void 0 ? void 0 : _a.addEventListener('connecting', (e) => {
            analytics.walletConnect(props.analyticsCategory, props.analyticsAction, props.analyticsLabel);
        });
    }, [connectBtn]);
    return (React.createElement(React.Fragment, null, arnClientReady && !window.isClothing && (React.createElement("div", { className: "account-wrapper__item" },
        React.createElement("arn-connect", { ref: connectBtn },
            React.createElement("button", { slot: "if-false", className: props.btnClass, disabled: !enabled },
                props.icon && React.createElement("span", { className: "mr-8 icon--walletconnect-logo" }),
                t(props.connectBtnLabel || 'walletconnect.btn.connect')),
            !props.hideDisconnectBtn && (React.createElement("button", { slot: "if-true", className: props.btnClass, disabled: !enabled },
                props.icon && React.createElement("span", { className: "mr-8 icon--walletconnect-logo" }),
                t('walletconnect.btn.disconnect'))))))));
};
export default WalletConnectBtn;
